import { render, staticRenderFns } from "./remainNew.vue?vue&type=template&id=32bf58b6&scoped=true&"
import script from "./remainNew.vue?vue&type=script&lang=js&"
export * from "./remainNew.vue?vue&type=script&lang=js&"
import style0 from "./remainNew.vue?vue&type=style&index=0&id=32bf58b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bf58b6",
  null
  
)

component.options.__file = "remainNew.vue"
export default component.exports